(() => {
  'use strict';
  const project = document.currentScript?.dataset.project;
  if (!project || window.GrowplayClarityLoader) return;
  window.GrowplayClarityLoader = true;
  window.clarity = window.clarity || function () {
    (window.clarity.q = window.clarity.q || []).push(arguments);
  };
  let started = false;
  let timer;
  const start = () => {
    if (started) return;
    started = true;
    clearTimeout(timer);
    document.removeEventListener('pointerdown', start);
    document.removeEventListener('keydown', start);
    if (document.querySelector('script[src*="clarity.ms/tag/"]')) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.clarity.ms/tag/' + encodeURIComponent(project);
    document.head.append(script);
  };
  document.addEventListener('pointerdown', start, {once: true, passive: true});
  document.addEventListener('keydown', start, {once: true});
  const schedule = () => { timer = setTimeout(start, 5000); };
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, {once: true});
})();
